<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name">{{ label }}</label>

    <Multiselect
      v-model="inputValue"
      mode="tags"
      :options="combinedOptions"
      :trackBy="'value'"
      :label="'label'"
      :valueProp="'value'"
      @update:modelValue="emitValue"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Multiselect from '@vueform/multiselect';
import { useFilterStore } from '@/store/filterStore.js';

const filterStore = useFilterStore();

const props = defineProps({
  value: { type: Array, default: () => [] },
  label: { type: String, required: true },
  name: { type: String, required: true },
  options: { type: Array, default: () => [] },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },
});

const inputValue = ref([...props.value]);

const currentOptions = computed(() => filterStore.optionsByProperty[props.property] || []);
const combinedOptions = computed(() =>
  currentOptions.value.map(item => ({ value: item.id, label: item.name })),
);

function normalizeToIds(arr) {
  if (!Array.isArray(arr)) return [];
  return arr
    .map(v => (typeof v === 'object' && v !== null ? v.value : v))
    .map(v => parseInt(v, 10))
    .filter(v => !Number.isNaN(v));
}

const emitValue = val => {
  const ids = normalizeToIds(val);

  filterStore.updateFilter({
    type: 'multi',
    property: props.property,
    value: ids,
  });

  filterStore.fetchDynamicCount({ mode: 'include' });
};

onMounted(() => {
  filterStore.loadAllSelectValues(props.property);
});
</script>
